
import { decodeToken } from '../utils/jwt/jwt-helper';
import { isWeb } from '../config/designSystem/Layout';
import { setOneSignalUser } from '../utils/onesignal/setUser';
import { setUser } from '../utils/sentry/sentry';


import { setId, setProperty } from '../utils/analytics/analytics';
import { useOneSignal } from '../components/Root/OneSignalContext';
import { useStores } from './useStores';


export const useInitAnalytics = () => {
  const rootStore = useStores();
  const {isInitialized} = useOneSignal();


  const oneSignalInit = (decodedData: any, lang: string, redirectTowardsReckoning = false, initOneSignal = false) => {
    if(isInitialized){
      setOneSignalUser(decodedData, lang, redirectTowardsReckoning, initOneSignal);
    }
  };

  const amplitudeInit = (decodedData: any, lang: string) => {
    if (!isWeb) {
      setId(decodedData._id);
      setProperty({
        languageUserDefined: lang,
        company: decodedData.companyName,
        _id: decodedData._id
      });
    }
  };

  const sentryInit = (decodedData: any) => {
    setUser(decodedData.email, decodedData._id);
  };

  const genericInit =  (decodedData: any, lang: string) => {
    sentryInit(decodedData);
    amplitudeInit(decodedData, lang);
  };

  const initAnalyticsWithDecodedData = async (decodedData: any): Promise<void> => {
    const lang = decodedData.preferredLanguage ? decodedData.preferredLanguage : rootStore?.language.name.key;
    genericInit(decodedData, lang);
    oneSignalInit(decodedData, lang);
  };


  const initAnalyticsForRegister = async (decodedData: any, redirectTowardsReckoning = false, initOneSignal = false): Promise<void> => {
    const lang = decodedData.preferredLanguage ? decodedData.preferredLanguage : rootStore?.language.name.key;
    genericInit(decodedData, lang);
    oneSignalInit(decodedData, lang, redirectTowardsReckoning,initOneSignal);
  };


  const initAnalyticsWithToken = async (token: string): Promise<void> => {
    const decodedData = decodeToken(token);
    initAnalyticsWithDecodedData(decodedData);

  };
  return {initAnalyticsWithDecodedData, initAnalyticsForRegister, initAnalyticsWithToken};
};